import React from "react";
import { Navigate } from "react-router-dom";
import { usePermissions } from "../../../../utils/permissions";

const destinos = [
  { to: "/dashboard/coordinacion/niveles", permission: "niveles.listar" },
  { to: "/dashboard/coordinacion/especialidades", permission: "especialidades.listar" },
  { to: "/dashboard/coordinacion/cursos", permission: "cursos.listar" },
  { to: "/dashboard/coordinacion/materias", permission: "materias.listar" },
  { to: "/dashboard/coordinacion/malla", permission: "malla.listar" },
  { to: "/dashboard/coordinacion/docentes", permission: "docentes.listar" },
  { to: "/dashboard/coordinacion/ciclos", permission: "ciclos.listar" },
  { to: "/dashboard/coordinacion/calendario", permission: "calendario.listar" },
  { to: "/dashboard/coordinacion/promociones", permission: "promociones.listar" },
];

export default function CoordinacionView() {
  const { hasPermission } = usePermissions();
  const destino = destinos.find((item) => hasPermission(item.permission))?.to;

  if (!destino) {
    return <Navigate to="/dashboard/view_dashboard" replace />;
  }

  return <Navigate to={destino} replace />;
}
